import { render, staticRenderFns } from "./AdjustmentHistory.vue?vue&type=template&id=12b647ed"
import script from "./AdjustmentHistory.vue?vue&type=script&lang=js"
export * from "./AdjustmentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b647ed')) {
      api.createRecord('12b647ed', component.options)
    } else {
      api.reload('12b647ed', component.options)
    }
    module.hot.accept("./AdjustmentHistory.vue?vue&type=template&id=12b647ed", function () {
      api.rerender('12b647ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/components/details/AdjustmentHistory.vue"
export default component.exports